import { isAfter } from 'date-fns'

const isTrialExpired = (expirationDate: string): boolean => {
	const currentDate = new Date()

	return isAfter(currentDate, new Date(expirationDate))
}

export default isTrialExpired
